
export interface MessageAttachmentModel {
  id?: number;
  fileName?: string;
  fileDate?: Date;
  fileSize?: number;
  fileType?: string;
  imageThumbnail?: string;
}
